import type { Components } from '@mui/material/styles';

export default function MUICircularProgress(): Components['MuiCircularProgress'] {
  return {
    defaultProps: {
      color: 'neutral',
    },
  };
}
